import { Headline, styled } from '@zeiss/beyond-online-react';

export const SectionHeadline: typeof Headline = styled(Headline)`
  /* Add space between headline and section text to match designs */
  margin-bottom: var(--spacing-xs);
`;
